import { render, staticRenderFns } from "./BlockContentProps.vue?vue&type=template&id=a38b0c52&"
import script from "./BlockContentProps.vue?vue&type=script&lang=js&"
export * from "./BlockContentProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports